import { MutationTree } from 'vuex';
import { State } from './state';
import { KeyValuePair, Land, Planung } from '@/modules/ewerp/models/PlanungModels';

export enum MutationTypes {
  GetPlanungSuccess = 'GETPLANUNGSUCCESS',
  GetPalettenProStunde = 'GETPALETTENPROSTUNDE',
  SetProduktionsauftraege = 'SETPRODUKTIONSAUFTRAEGE',
  UpdateProduktionsauftrag = 'UPDATEPRODUKTIONSAUFTRAEG',
  ClearPlanung = 'CLEARPLANUNG',
  SetLaender = 'SETLAENDER',
}

export type Mutations = {
  [MutationTypes.GetPlanungSuccess](state: State, data: Array<Planung>): void;
  [MutationTypes.GetPalettenProStunde](state: State, data: Array<KeyValuePair>): void;
  [MutationTypes.SetProduktionsauftraege](state: State, data: Array<Planung>): void;
  [MutationTypes.UpdateProduktionsauftrag](state: State, data: Planung): void;
  [MutationTypes.ClearPlanung](state: State): void;
  [MutationTypes.SetLaender](state: State, data: Array<Land>): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.GetPlanungSuccess](state: State, data: Array<Planung>) {
    state.planung = data;
  },

  [MutationTypes.GetPalettenProStunde](state: State, data: Array<KeyValuePair>) {
    state.palettenProStunde = data;
  },

  [MutationTypes.SetProduktionsauftraege](state: State, data: Array<Planung>) {
    state.produktionsauftraege = data;
  },

  [MutationTypes.UpdateProduktionsauftrag](state: State, data: Planung) {
    const index = state.produktionsauftraege.findIndex((auftrag) => auftrag.id === data.id);
    if (index !== -1) {
      state.produktionsauftraege.splice(index, 1, data);
    }
  },

  [MutationTypes.ClearPlanung](state: State) {
    state.planung = new Array<Planung>();
    state.palettenProStunde = new Array<KeyValuePair>();
  },

  [MutationTypes.SetLaender](state: State, data: Array<Land>) {
    state.laender = data;
    sessionStorage.setItem('laender', JSON.stringify(state.laender));
  },
};
